<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Search -->
            <b-col
                cols="12"
                md="8"
                class=""
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="debouncedSearch"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector mx-50 w-50"
              />
              <label>تعداد</label>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span> تعداد کل : </span>
              <span class="mx-1">{{ totalCount }}</span>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">شروع تاریخ از : </label>
              <input
                  type="text"
                  id="startPaymentDate"
                  :value="createJalaliDate(from)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="from"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  class=""
                  element="startPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <label class="mr-1">تا : </label>
              <input
                  type="text"
                  id="endPaymentDate"
                  :value="createJalaliDate(to)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              />
              <custom-date-picker
                  v-model="to"
                  format="YYYY-MM-DD"
                  display-format="jYYYY/jMM/jDD"
                  class=""
                  element="endPaymentDate"
                  type="date"
                  color="#5c6bc0"
                  simple
                  class="position-absolute p-0"
              ></custom-date-picker>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mt-1"
            >
              <b-button
                  variant="warning"
                  @click="getWinners"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              >
                جستجو با تاریخ
              </b-button>
            </b-col>

<!--            <b-col-->
<!--                cols="12"-->
<!--                md="2"-->
<!--                class="d-flex align-items-center justify-content-start mb-md-0"-->
<!--            >-->
<!--              <b-button-->
<!--                  variant="success"-->
<!--                  class=""-->
<!--                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"-->
<!--                  @click="downloadFile"-->
<!--              >-->
<!--                دانلود اکسل لیست-->
<!--              </b-button>-->
<!--            </b-col>-->
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="winners"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <!-- Column: createDate -->
          <template #cell(createDate)="data">
            <span>
              {{data.item.createDate.slice(11,16)}}
              -
              {{createJalaliDate(data.item.createDate.slice(0,10))}}
            </span>
          </template>

          <!-- Column: prizeType -->
          <template #cell(prizeType)="data">
            <span v-if="data.item.prizeType === 1">پوچ</span>
            <span v-if="data.item.prizeType === 2">کوپن</span>
            <span v-if="data.item.prizeType === 3">مانترا باصدای استاد</span>
            <span v-if="data.item.prizeType === 4">دیدار با استاد</span>
            <span v-if="data.item.prizeType === 5">مانترا</span>
            <span v-if="data.item.prizeType === 6">دوباره بچرخون</span>
            <span v-if="data.item.prizeType === 7">بوس به کلت</span>
            <span v-if="data.item.prizeType === 8">روزی امروزت</span>
            <span v-if="data.item.prizeType === 9">ایشالا دفعه دیگه</span>
            <span v-if="data.item.prizeType === 10">استیکر استاد</span>
            <span v-if="data.item.prizeType === 11">شارژ کیف پول</span>
            <span v-if="data.item.prizeType === 12">گردش با استاد</span>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <QueriedPagination v-if="totalCount" v-model="currentPage" :total-counts="totalCount"
                                 :per-page="perPage"></QueriedPagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
    <!--    <b-modal-->
    <!--        id="modal-delete"-->
    <!--        centered-->
    <!--        ok-title="حذف"-->
    <!--        cancelTitle="انصراف"-->
    <!--        @ok="deleteCoupon(deleteItem)"-->
    <!--    >-->
    <!--      <span>حذف شود؟</span>-->
    <!--    </b-modal>-->
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BPagination,BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {CouponGetAllRequest} from "@/libs/Api/Coupon";
import {CouponDeleteRequest} from "@/libs/Api/Coupon";
import Helper from "@/libs/Helper";
import {NumberGetAllRequest} from "@/libs/Api/Number";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import {PrizeGetPrizeWinnersForHangoutOrVisitRequest} from "@/libs/Api/Prize";
import QueriedPagination from "@/views/components/QueriedPagination.vue";

export default {
  name: "Winners",
  title:"لیست برندگان - پنل ادمین ذهن آرایی",
  data(){
    return{
      coupons:null,
      winners:[],
      showOverlay:false,
      totalCount:null,
      addNewCategory:false,
      currentPage:1,
      deleteItem:null,
      perPage:10,
      pageNumber:1,
      count:10,
      searchCommand:'',
      perPageOptions:[10, 20, 30 , 40 , 50],
      myTableColumns : [
        { key: 'userFullName',label:'شناسه'},
        { key: 'mobile',label:'شماره موبایل'},
        { key: 'prizeType',label:'جایزه'},
        { key: 'createDate',label:'تاریخ ثبت'},
      ],
      defaultCreateData:{
        isDeleted:false,
        productCategoryId:0,
        parentId:0,
        name:''
      },
      searchQuery: '',
      from:'',
      to:'',
    }
  },
  async created(){
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getWinners()
  },
  methods:{
    async getWinners(){
      let  _this = this;

      _this.showOverlay = true;

      let data = {
        page:_this.currentPage,
        count:_this.perPage,
        search:_this.searchQuery,
        from:_this.from,
        to:_this.to
      }

      let prizeGetPrizeWinnersForHangoutOrVisitRequest = new PrizeGetPrizeWinnersForHangoutOrVisitRequest(_this);
      prizeGetPrizeWinnersForHangoutOrVisitRequest.setParams(data);
      await prizeGetPrizeWinnersForHangoutOrVisitRequest.fetch(function (content){
        _this.winners = content.data.data;
        _this.totalCount = content.data.totalCount;
        _this.showOverlay = false;
      },function (error){
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async deleteCoupon(param){
      let _this = this;

      let couponDeleteRequest = new CouponDeleteRequest(_this);
      couponDeleteRequest.setId(param);
      await couponDeleteRequest.fetch(function (content){
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `کوپن حذف شد.`,
          },
        })
        _this.getWinners(_this.pageNumber,_this.count,_this.searchCommand)
      },function (error){
        console.log(error)
      })
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post(`Number/GetExcel`, null, {
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست کوپن‌های بدون عضویت.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
    createJalaliDate(param) {
      if (param !== null && param !== '') {
        return new Date(param).toLocaleDateString("fa-IR",);
      }
    },
    showModal(param){
      let _this = this;
      _this.deleteItem = param
    },
  },
  watch:{
    getQuery: function (nv, ov) {
      this.getWinners();
    },
    perPage:function (nv,ov) {
      this.getWinners();
    },
    searchQuery:function (nv,ov) {
      this.getWinners();
    },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
    debouncedSearch: {
      get() {
        return this.searchQuery
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          this.searchQuery = val
        }, 600)
      }
    }
  },
  components:{
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BOverlay,
    vSelect,
  },
}
</script>

<style scoped>

</style>